// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal___S1Y_n","goto1":"goto1___2SWGS","goto2":"goto2___3ZDjo"};